exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* Force le fond vert sur toute la page de register */\nbody {\r\n    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;\r\n    min-height: 100vh;\n}\r\n/* Force également sur l'app-container pour la page register */\n.app-container[\\:has\\(.register-page\\)] {\r\n    min-height: 100vh !important;\r\n    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;\n}\n.app-container:has(.register-page) {\r\n    min-height: 100vh !important;\r\n    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;\n}\r\n", ""]);

// exports
